import * as React from "react";
import {Component} from "react";
import {DashboardValueVsExpectedCell} from "../base/DashboardValueVsExpectedCell";

export class DashboardFullPeriodCPAVsPeriodCell extends Component {
    render() {
        return <DashboardValueVsExpectedCell value={this.props.columnData.formatted_expected_value}
                                             alertLevel={this.props.columnData.alert_level}
                                             alertSnoozed={this.props.columnData.alert_snoozed}
                                             fluctuation={this.props.columnData.fluctuation}
                                             fluctuationPercentage={this.props.columnData.fluctuation_percentage}
                                             title={this.props.columnTooltip}
                                             status={this.props.columnData.status}
                                             hasMetaActionsAndAreNotSet={this.props.columnData.has_meta_actions_and_are_not_set}
                                             businessUnitId={this.props.businessUnitId}
        />;
    }
}
